import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { environment } from '@env/environment';
import { AuthService } from '@services/auth/auth.service';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

export const reqInterceptor: HttpInterceptorFn = (req, next) => {
    const authService = inject(AuthService);
    const token = authService.getToken();

    if (token) {
        if (req.url.startsWith(environment.apiEndpoint)) {
            const authReq = req.clone({
                setHeaders: {
                    Authorization: `Bearer ${token}`,
                },
            });
            return next(authReq);
        }
    }

    return next(req).pipe(
        catchError((error) => {
            if (error.status === 401) {
                authService.logout();
            }
            return throwError(() => error);
        }),
    );
};
